import { CURRENT, FAIL, GETALLUSERS, GETONEUSER, LOGIN, LOGOUT, REGISTER } from "../ActionTypes/AuthTypes"
import axios from 'axios'
import { handleerror } from "./ErrorsActions"

export const register = (cordUser, navigate) => async (dispatch) => {
  try {
    const res = await axios.post("/api/auth/SignUp", cordUser);

    localStorage.setItem('token', res.data.token);
    if (res.data.newUser) {
      localStorage.setItem('user', JSON.stringify(res.data.newUser));
    }

    dispatch({
      type: REGISTER,
      payload: res.data,
    });

    navigate("/");
  } catch (error) {
    console.log("Erreur Register :", error.response?.data || error.message);

    if (error.response?.data?.errors) {
      error.response.data.errors.forEach((el) =>
        dispatch(handleerror(el.msg))
      );
    } else {
      dispatch(handleerror("Une erreur est survenue lors de l'inscription."));
    }
  }
};

export const login = (cordUser, navigate) => async (dispatch) => {
  try {
    const res = await axios.post('/api/auth/SignIn', cordUser);

    console.log('🔍 RÉPONSE LOGIN:', res.data);
    console.log('🎯 RÔLE UTILISATEUR:', res.data.user?.role);
    console.log('📍 LOCALISATION:', res.data.user?.localisation);

    // Stocker dans localStorage
    localStorage.setItem('token', res.data.token);
    if (res.data.user) {
      localStorage.setItem('user', JSON.stringify(res.data.user));

      // Stocker la localisation pour le filtrage
      if (res.data.user.localisation && res.data.user.localisation.name) {
        localStorage.setItem('userLocation', res.data.user.localisation.name);
        console.log('✅ userLocation enregistré:', res.data.user.localisation.name);
      } else {
        console.warn('⚠️ Pas de localisation pour cet utilisateur');
        localStorage.removeItem('userLocation'); // Nettoyer si pas de localisation
      }
    }

    const loginPayload = {
      user: res.data.user || res.data.found,
      token: res.data.token,
      msg: res.data.msg,
      localisationName: (res.data.user?.localisation?.name || res.data.found?.localisation?.name)
    };

    dispatch({
      type: LOGIN,
      payload: loginPayload
    });

    // Rediriger vers la page d'accueil dans l'application Reservation dédiée
    navigate('/');

  } catch (error) {
    console.error('❌ Erreur login:', error.response?.data || error);

    if (error.response?.data?.errors) {
      error.response.data.errors.forEach(el => dispatch(handleerror(el.msg)));
    } else {
      dispatch(handleerror("Erreur de connexion"));
    }
  }
}

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('userLocation');

  return {
    type: LOGOUT
  }
}

export const current = () => async (dispatch) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }

    const res = await axios.get('/api/auth/CurrentUser', config);

    dispatch({
      type: CURRENT,
      payload: res.data
    });

  } catch (error) {
    console.error('Erreur current user:', error);
    dispatch(logout());

    if (error.response?.data?.errors) {
      error.response.data.errors.forEach(element => {
        dispatch(handleerror(element.msg));
      });
    } else {
      dispatch(handleerror("Erreur de chargement du profil"));
    }
  }
}

export const getAllusers = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/auth/AllUser');

    dispatch({
      type: GETALLUSERS,
      payload: res.data.AllUser
    });

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de chargement des utilisateurs"));
  }
}

export const getOneUser = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/auth/OneUser/${id}`);

    dispatch({
      type: GETONEUSER,
      payload: res.data.OneUser
    });

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de chargement de l'utilisateur"));
  }
}

export const updateUser = (id, cordUser, navigate) => async (dispatch) => {
  try {
    await axios.put(`/api/auth/UpdateUser/${id}`, cordUser);

    dispatch(getAllusers());
    navigate('/AllUser');

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de mise à jour de l'utilisateur"));
  }
}

export const deleteUser = (id) => async (dispatch) => {
  try {
    await axios.delete(`/api/auth/DeleteUser/${id}`);
    dispatch(getAllusers());

  } catch (error) {
    console.log(error);
    dispatch(handleerror("Erreur de suppression de l'utilisateur"));
  }
}

export const updateProfil = (id, cordUser, navigate) => async (dispatch) => {
  try {
    const res = await axios.put(`/api/auth/UpdateUser/${id}`, cordUser);

    if (res.data.token) {
      localStorage.setItem('token', res.data.token);
    }
    if (res.data.user) {
      localStorage.setItem('user', JSON.stringify(res.data.user));
    }

    dispatch(current());
    navigate('/Profil');

  } catch (error) {
    console.error('Erreur mise à jour profil:', error);
    dispatch(handleerror("Erreur de mise à jour du profil"));
  }
};